export default __webpack_public_path__ + "static/media/ip4X.e1e09303.svg";